import { type ZodSchema, z } from 'zod';

export const CampaignPlanValidator: ZodSchema = z.object({
  _id: z.optional(z.string()),
  completed: z.boolean(),
  countries: z.array(z.string()).min(1),
  iabCategories: z.array(z.string()).min(1),
  mediaAdvertiserUser: z.string().min(6),
  name: z.string().min(3),
  sentToBidder: z.optional(z.boolean()),
  syncError: z.optional(z.boolean()),
  user: z.string()
});
